
import React from 'react';
import { Link } from 'react-router-dom';

interface LogoProps {
  scrolled: boolean;
}

const Logo: React.FC<LogoProps> = ({ scrolled }) => {
  return (
    <Link to="/" className="flex items-center group">
      <div className="h-24 w-auto mr-2 flex items-center justify-center overflow-hidden">
        <img 
          src="https://i.imgur.com/qvgtBeK.png" 
          alt="Future Level Logo" 
          className="h-full w-auto object-contain"
        />
      </div>
    </Link>
  );
};

export default Logo;
